import { render } from "./ManagementFlagsComparisonBlock.vue?vue&type=template&id=3c36f682&scoped=true"
import script from "./ManagementFlagsComparisonBlock.vue?vue&type=script&lang=js"
export * from "./ManagementFlagsComparisonBlock.vue?vue&type=script&lang=js"

import "./ManagementFlagsComparisonBlock.vue?vue&type=style&index=0&id=3c36f682&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c36f682"]])

export default __exports__